import i18n from '@/i18n';
import { isClientError } from 'cesg-shared';
import type { NotificationMatcher } from './notification-matcher';

export const fileTooLargeNotification: NotificationMatcher = (error) => {
  if (!isClientError(error, 'FILE_TOO_LARGE')) return null;

  const { t } = i18n.global;
  const { maxMb, uploadedMb } = error.payload.data;
  const text =
    uploadedMb === undefined
      ? t('errorNotifications.FILE_TOO_LARGE.text', { maxMb: maxMb.toFixed(1) })
      : t('errorNotifications.FILE_TOO_LARGE.textWithSize', {
          maxMb: maxMb.toFixed(1),
          uploadedMb: uploadedMb.toFixed(1),
        });

  return {
    title: t('errorNotifications.FILE_TOO_LARGE.title'),
    text,
    type: 'danger',
  };
};
